import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const insertInformationDataTypes = getApiActionTypes(
  'K1_INFORMATION/INSERT_INFORMATION_DATA',
);
export const fetchFilterDataTypes = getApiActionTypes('K1_INFORMATION/FETCH_FILTER_DATA');
export const fetchFormFieldsTypes = getApiActionTypes('K1_INFORMATION/FETCH_FROM_FIELDS');
export const updateFormFieldsTypes = getApiActionTypes('K1_INFORMATION/UPDATE_FORM_FIELDS');
